import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import {serviceFields} from '../../../../data/shared/fragments';
import Section from './section';
import JobCard from '../../../../shared/library/cards/jobs/jobs-card';
import {MobileContext} from '../../../../shared/enhancers/mobile-enhancer';

export const query = gql`
  query jobs($id: ID!, $first: Int, $after: String) {
    company(id: $id) {
      id
      jobs(first: $first, after: $after) {
        count
        edges {
          node {
            id
            angellistJobUrl
            title
            location
            private
            services {
              ...serviceFields
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
  ${serviceFields}
`;

const Jobs = ({companyId, count}) => {
  const isMobile = useContext(MobileContext);
  return (
    <Section
      title="Jobs"
      count={count}
      query={query}
      dataKey="jobs"
      variables={{id: companyId}}
      gridCols={isMobile ? 1 : 2}
    >
      {({edges}) =>
        edges
          ? edges.map(e => (
              <JobCard
                id={e.node.id}
                key={e.node.id}
                url={e.node.angellistJobUrl}
                title={e.node.title}
                location={e.node.location}
                services={e.node.services}
                isPrivate={e.node.private}
              />
            ))
          : null
      }
    </Section>
  );
};

Jobs.propTypes = {
  companyId: PropTypes.any.isRequired,
  count: PropTypes.number.isRequired
};

export default Jobs;
